export const useUniformResolution = () => {
  const { renderer, sizes } = useTresContext()

  const uResolution = {
    value: new Vector2(sizes.width.value, sizes.height.value),
  }

  watchEffect(() => {
    // const dpr = window.devicePixelRatio
    const dpr = renderer.value.getPixelRatio()
    uResolution.value.x = sizes.width.value * dpr
    uResolution.value.y = sizes.height.value * dpr
  })

  return uResolution
}
